import { useEffect, useRef, useState } from "react";

import { useENTStore } from "../../Store/useEntReport";
import { fetchReportData } from "../../services/network";
import Phi from "../../Phi/Phi";

import {
  ReportRXData,
  reportStrings,
} from "../../utils/helpers/newReportHelper";

import {
  AccessibilityIconSvg,
  EarSvgIcon,
  EarSvgicon2,
  EditSvg,
  GirlIconSvg,
  MouthSvgIcon,
  NeckSvgIcon,
  SearchSuggestionIconSvg,
  UserIconSvg,
} from "../../utils/Svgs";

import { PALLETTE } from "../../utils/theme";
import { V2ReportStyle } from "../../styles/V2ReportStyle";

import StudentCard from "../../Components/UI/StudentCard";
import ComplaintsCard from "../../Components/UI/ComplaintsCard";
import MultilineTextBox from "../../Components/UI/MultilineTextBox";
import Precaution from "../../Components/UI/Precaution";
import ReportFooter from "../../Components/UI/ReportFooter";
import SuggestedInvestigationCard from "../../Components/UI/SuggestedInvestigationCard";
import SectionHeading from "../../Components/UI/SectionHeading";
import SimpleLoader from "../../Components/Loaders/SimpleLoader";

import { NoseImg, ThroatImg } from "../../Assets/images";
import Page from "./Page";
import ScreenShotWrapper from "../../Components/report/ScreenShotWrapper";
import { useUserStore } from "../../Store/userStore";
import { generateReportLogic } from "../../services/reportService";
import ReportHeader from "../../Components/report/ReportHeader";
import AssessmentNotDoneWrapper from "../../Components/report/AssessmentNotDoneWrapper";

const ENTReportScreen = ({ location }: { location: any }) => {
  const { handleMspLogo, mspLogo } = useUserStore((state) => state);
  const sessionData = sessionStorage.getItem("report_navigation_state");
  const storedParams = sessionData ? JSON.parse(sessionData) : {};
  const [assessmentError, setAssessmentError] = useState(null);
  // Reads location.state if navigated internally, falls back to sessionStorage for new tab
  const params = location?.state || storedParams;
  const EarReportData = useENTStore((state) => state.EarReportData);
  const ENTMetaData = useENTStore((state) => state.ENTMetaData);
  const ENTOtherData = useENTStore((state) => state.ENTOtherData);
  const NoseData = useENTStore((state) => state.NoseData);
  const ThroatData = useENTStore((state) => state.ThroatData);
  const NeckData = useENTStore((state) => state.NeckData);
  const ENT_Suggested_Investigation_Data = useENTStore(
    (state) => state.ENT_Suggested_Investigation_Data,
  );
  const NeedAttention = useENTStore((state) => state.NeedAttention);

  const setENTReportData = useENTStore((state) => state.setENTReportData);

  const resetENTReport = useENTStore((state) => state.resetENTReport);

  const [isLoading, setLoading] = useState(false);

  const pdfWrapperRef = useRef<any>(null);

  const studentId = params?.user_id || params?.student_id;
  const eventTrackId = params?.eventTrackId;
  const activityId = params?.activityId;

  const jwt = Phi.getSession()?.jwt;

  const getchData = async (activity_id: number, assessmentId: number) => {
    try {
      setLoading(true);

      const res = await fetchReportData({
        activity_id,
        student_id: studentId,
        jwt,
        event_track_id: assessmentId,
      });

      if (res?.results?.length > 0) {
        const parsedAssessment = JSON.parse(res.results[0].assessmentdata);

        setENTReportData(parsedAssessment?.data);
        await generateReportLogic({
          jwt: jwt,
          studentId: studentId,
          handleMspLogo,
        });
      }
    } catch (error) {
      console.error("error getting ENT report", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getchData(activityId, eventTrackId);

    return () => {
      resetENTReport();
    };
  }, [activityId, eventTrackId]);

  return (
    <div
      style={{
        ...V2ReportStyle.mainContainer,
        backgroundColor: PALLETTE.white,
        minHeight: "100vh",
      }}
    >
      {isLoading ? (
        <SimpleLoader />
      ) : (
        <>
          <ReportHeader title="ENT Report" pdfWrapperRef={pdfWrapperRef} />

          <ScreenShotWrapper
            ref={pdfWrapperRef}
            studentName={params?.name || params?.studentname}
            reportType="ENT"
          >
            {(targetRef: any) => (
              <div
                ref={targetRef}
                style={{
                  padding: "3rem",
                  backgroundColor: PALLETTE.background,
                }}
              >
                {assessmentError ? (
                  <AssessmentNotDoneWrapper>
                    <StudentCard
                      name={params?.name || params?.studentname}
                      schoolName={params?.class}
                      icon={
                        params?.gender === "FEMALE" || params?.gender == "F" ? (
                          <GirlIconSvg />
                        ) : (
                          <UserIconSvg />
                        )
                      }
                    />
                  </AssessmentNotDoneWrapper>
                ) : (
                  <Page>
                    {/* Student Card */}

                    <StudentCard
                      name={params?.name || params?.studentname}
                      schoolName={params?.class}
                      icon={
                        params?.gender === "FEMALE" || params?.gender == "F" ? (
                          <GirlIconSvg />
                        ) : (
                          <UserIconSvg />
                        )
                      }
                    />

                    {/* Ear Section */}

                    <SectionHeading icon={<EarSvgicon2 />} title="Ear" />

                    <ComplaintsCard
                      label={
                        NeedAttention?.rightEar ? "Need Attention" : "Normal"
                      }
                      remark={ENTOtherData?.Right_Ear_Others}
                      data={EarReportData?.clinicalEntExamination?.rightEar}
                      title="Right Ear"
                      topLefticon={<EarSvgIcon />}
                      suggestionText={
                        NeedAttention?.rightEar ? reportStrings?.rightEar : ""
                      }
                    />

                    <ComplaintsCard
                      label={
                        NeedAttention?.leftEar ? "Need Attention" : "Normal"
                      }
                      remark={ENTOtherData?.Left_Ear_Others}
                      data={EarReportData?.clinicalEntExamination?.leftEar}
                      title="Left Ear"
                      topLefticon={<EarSvgIcon />}
                      suggestionText={
                        NeedAttention?.leftEar ? reportStrings?.leftEar : ""
                      }
                    />

                    {/* Nose */}

                    <ComplaintsCard
                      label={NeedAttention?.nose ? "Need Attention" : "Normal"}
                      remark={ENTOtherData?.Nose_Others}
                      data={NoseData}
                      imageSource={NoseImg}
                      title="Nose"
                      topLefticon={<AccessibilityIconSvg />}
                      suggestionText={
                        NeedAttention?.nose ? reportStrings?.nose : ""
                      }
                    />

                    {/* Throat */}

                    <ComplaintsCard
                      label={
                        NeedAttention?.throat ? "Need Attention" : "Normal"
                      }
                      remark={ENTOtherData?.Oral_Cavity_Throat_Others}
                      data={ThroatData}
                      imageSource={ThroatImg}
                      title="Throat"
                      topLefticon={<MouthSvgIcon />}
                      suggestionText={
                        NeedAttention?.throat ? reportStrings?.throat : ""
                      }
                    />

                    {/* Neck */}

                    <ComplaintsCard
                      label={NeedAttention?.neck ? "Need Attention" : "Normal"}
                      remark={ENTOtherData?.Neck_Others}
                      data={NeckData}
                      title="Neck"
                      topLefticon={<NeckSvgIcon />}
                      suggestionText={
                        NeedAttention?.neck ? reportStrings?.neck : ""
                      }
                    />

                    {/* Doctor Remarks */}

                    {ENTMetaData?.ENT_Doctor_Remarks && (
                      <div style={V2ReportStyle.card}>
                        <MultilineTextBox
                          description={ENTMetaData?.ENT_Doctor_Remarks}
                          label="Remarks"
                          icon={<EditSvg />}
                        />
                      </div>
                    )}

                    {/* Suggested Investigations */}

                    <SuggestedInvestigationCard
                      label={
                        NeedAttention?.suggestedInvestigation
                          ? "Need Attention"
                          : "Normal"
                      }
                      remark={ENTOtherData?.ENT_Other_Tests}
                      data={ENT_Suggested_Investigation_Data}
                      title="Suggested Investigations"
                      topLefticon={<SearchSuggestionIconSvg />}
                    />

                    {/* Precautions */}

                    <Precaution data={ReportRXData?.ent} />

                    {/* Footer */}

                    <ReportFooter
                      doctorName={ENTMetaData?.ENT_Doctor_No}
                      designation={ENTMetaData?.ENT_Doctor_Designation}
                      docSignature={ENTMetaData?.ENT_Doctor_Path}
                      hospitalName={mspLogo[eventTrackId]}
                    />
                  </Page>
                )}
              </div>
            )}
          </ScreenShotWrapper>
        </>
      )}
    </div>
  );
};

export default ENTReportScreen;
